module.exports = __webpack_public_path__ + "img/other.6bffa6f7.svg";